import { Skeleton } from "antd";
import React from "react";

/**
 * Render a skeleton for the upcoming booking component.
 *
 * @return {JSX} The skeleton for the upcoming booking component.
 */
export const UpcomingBookingSkeleton = () => {
  return (
    <div className="grid grid-cols-[79px,1fr] rounded-lg border border-[#E9F1FD]">
      <div className="flex h-[83px] items-center justify-center bg-[#E9F1FD]">
        <span className="text-center text-[16px] font-medium text-primary lg:text-[18px]"></span>
      </div>
      <div className="flex grow flex-col items-start gap-1 p-[8px_12px_7px]">
        <div className="flex w-full items-start justify-between">
          <Skeleton.Input style={{ width: 100 }} active={true} size="small" />
          <Skeleton.Button active={true} size="small" />
        </div>
        <Skeleton.Input style={{ width: 60 }} active={true} size="small" />
      </div>
    </div>
  );
};
